export default __webpack_public_path__ + "static/media/cad_machined.2132615b.svg";